export const dclStatusOptions = [
    {value: "open", label: "Εκκρεμής"}, {value: "completed", label: "Ολοκληρωμένη"}, {value: "cancelled", label: "Ακυρωμένη"}
];

export const offSiteProvidedServiceOptions = [
    {label: "Κενό", value: ""},
    {label: "Μετακίνηση σε συνεργαζόμενη οντότητα", value: "1"},
    {label: "Μετακίνηση σε εγκατάσταση εντός της ίδιας οντότητας", value: "2"}
]

export const providedServiceCategoryOptions = [
    {value: "1", label: "Εργασία με χρήση ανταλλακτικών"},
    {value: "2", label: "Εργασία με χρήση ανταλλακτικών πελάτη"},
    {value: "3", label: "Εργασία χωρίς χρήση ανταλλακτικών"},
    {value: "4", label: "Δωρεάν υπηρεσία"},
    {value: "5", label: "Λοιπά"},
    {value: "6", label: "Αποζημίωση Παροχής Εγγύησης"},
    {value: "7", label: "Υπηρεσία Βάσει Τιμοκαταλόγου"},
    {value: "8", label: "Υπηρεσία Βάση Συμφωνίας"},
    {value: "9", label: "Ιδιόχρηση"}
]

export const providedServiceCategoryOptionsForIssue = [
    {value: "1", label: "Εργασία με χρήση ανταλλακτικών"},
    {value: "2", label: "Εργασία με χρήση ανταλλακτικών πελάτη"},
    {value: "3", label: "Εργασία χωρίς χρήση ανταλλακτικών"},
    {value: "5", label: "Λοιπά"},
    {value: "7", label: "Υπηρεσία Βάσει Τιμοκαταλόγου"},
    {value: "8", label: "Υπηρεσία Βάση Συμφωνίας"}
]
export const providedServiceCategoryOptionsForNoIssue = [
    {value: "4", label: "Δωρεάν υπηρεσία"},
    {value: "6", label: "Αποζημίωση Παροχής Εγγύησης"},
    {value: "9", label: "Ιδιόχρηση"}
]

export const serviceTypeOptionsSettings = [
    {value: "oneTime", label: "Άπαξ"},
    {value: "recurring", label: "Επαναλαμβανόμενη"},
    {value: "continuous", label: "Διαρκής/Λήψη Δικαιώματος"},
    {value: "continuousLease", label: "Διαρκής Μίσθωση/Υπηρεσία"}
];

export const transmissionFailureOptions = [
    {value: "showAll", label: "Εμφάνιση Όλων"},
    {value: "1", label: "Εμφάνιση μόνο αποτυχημένων"},
    {value: "2", label: "Εμφάνιση μόνο επιτυχημένων"},
]
